import { render, staticRenderFns } from "./UPSShipV2.vue?vue&type=template&id=402f27bd&scoped=true"
import script from "./UPSShipV2.vue?vue&type=script&lang=js"
export * from "./UPSShipV2.vue?vue&type=script&lang=js"
import style0 from "./UPSShipV2.vue?vue&type=style&index=0&id=402f27bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402f27bd",
  null
  
)

export default component.exports